import { useState } from 'react';
import { useError } from '../contexts/ErrorContext';
import { useAuth } from '../contexts/AuthContext';

export const useApi = (apiFunc) => {
  const [loading, setLoading] = useState(false);
  const { showError } = useError();
  const { logout } = useAuth(); // For forced logout on auth errors

  const execute = async (...args) => {
    try {
      setLoading(true);
      return await apiFunc(...args);
    } catch (err) {
      if (err.message === 'unauthorized' || err.message.includes('revoked')) {
        logout();
        showError("Your session has expired or access was revoked. Please log in again.");
      } else {
        showError(err.message || 'An unexpected error occurred. Please try again.');
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { execute, loading };
};